import { InputHTMLAttributes, ReactNode, forwardRef } from 'react'

interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string
  subtext?: string
  icon?: ReactNode
  error?: string
  className?: string
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, subtext, icon, error, disabled, className = '', ...props }, ref) => {
    return (
      <div className={`relative ${className}`}>
        <label className="group flex items-center w-full">
          <input
            type="radio"
            ref={ref}
            disabled={disabled}
            className="absolute opacity-0 peer"
            {...props}
          />
          <div className='bg-zinc-100 w-12 h-12 rounded-full flex items-center justify-center mr-5'>
            {icon}
          </div>

          <div className="flex flex-col flex-1">
            <span className="font-medium text-base text-zinc-900 peer-disabled:text-gray-400">
              {label}
            </span>
            {subtext && (
              <span className="text-sm text-zinc-600 mt-1">
                {subtext}
              </span>
            )}
          </div>
          <div className="relative w-6 h-6 ml-auto rounded-full border-2 border-gray-300 peer-checked:border-blue-600 transition-colors duration-200 flex items-center justify-center"></div>
          <div className="absolute right-[0.375rem] w-3 h-3 rounded-full transition-colors duration-200 bg-transparent peer-checked:bg-blue-600"></div>
        </label>
        {error && (
          <span className="text-sm text-red-500 mt-1">
            {error}
          </span>
        )}
      </div>
    )
  }
)

Radio.displayName = 'Radio'

export default Radio